import type React from "react";
import { TriangleAlert, Edit2 } from "lucide-react";
import { VendorRiskLevel } from "./OverviewCards.types";

type Props = {
  riskLevel: VendorRiskLevel;
  showIcon?: boolean;
  showEditIcon?: boolean;
};

const RiskLevelChip = ({ riskLevel, showIcon = false, showEditIcon = false }: Props) => {
  const chipStyles = {
    High: {
      background: 'linear-gradient(0deg, rgba(211, 47, 47, 0.1), rgba(211, 47, 47, 0.1)), #FFFFFF',
      border: '1px solid #FFD1D2',
      color: '#D32F2F',
    },
    Medium: {
      background: 'linear-gradient(0deg, rgba(245, 165, 36, 0.1), rgba(245, 165, 36, 0.1)), #FFFFFF',
      border: '1px solid rgba(245, 165, 36, 0.2)',
      color: '#F5A524',
    },
    Low: {
      background: 'linear-gradient(0deg, rgba(23, 201, 100, 0.1), rgba(23, 201, 100, 0.1)), #FFFFFF',
      border: '1px solid rgba(23, 201, 100, 0.2)',
      color: '#17C964',
    },
  };

  const style = chipStyles[riskLevel];

  return (
    <div
      style={{
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2px 8px',
        gap: '6px',
        minWidth: 'auto',
        height: '20px',
        background: style.background,
        border: style.border,
        borderRadius: '4px',
        flex: 'none',
      }}
    >
      {showIcon && (
        <TriangleAlert
          style={{
            width: '12px',
            height: '12px',
            color: style.color,
            flexShrink: 0,
            flex: 'none',
            order: 0,
          }}
        />
      )}
      <span
        style={{
          height: '16px',
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: '12px',
          lineHeight: '16px',
          textAlign: 'center',
          textTransform: 'uppercase',
          color: style.color,
          flex: 'none',
          order: 1,
          whiteSpace: 'nowrap',
        }}
      >
        {riskLevel} Risk
      </span>
      {showEditIcon && (
        <Edit2
          style={{
            width: '12px',
            height: '12px',
            color: style.color,
            flexShrink: 0,
            flex: 'none',
            order: 2,
          }}
        />
      )}
    </div>
  );
};

export default RiskLevelChip;
